package link.erpango.quip.utils

import kotlinx.browser.document
import kotlinx.datetime.DateTimeUnit
import kotlinx.datetime.Instant
import kotlinx.datetime.LocalDate
import kotlinx.datetime.TimeZone
import kotlinx.datetime.plus
import kotlinx.datetime.toLocalDateTime
import org.w3c.dom.HTMLAnchorElement

class JsCalendarUtils : ICalendarUtils {

    override fun addEvent(title: String, description: String, startMs: Long) {
        val tz = TimeZone.currentSystemDefault()
        val startInstant = Instant.fromEpochMilliseconds(startMs)
        val startDate = startInstant.toLocalDateTime(tz).date
        val endDate = startDate.plus(1, DateTimeUnit.DAY)

        fun LocalDate.toIcsDate() =
            "${year}${monthNumber.toString().padStart(2, '0')}${dayOfMonth.toString().padStart(2, '0')}"

        val icsContent = buildString {
            appendLine("BEGIN:VCALENDAR")
            appendLine("VERSION:2.0")
            appendLine("PRODID:-//Quip//Quip App//EN")
            appendLine("BEGIN:VEVENT")
            appendLine("DTSTART;VALUE=DATE:${startDate.toIcsDate()}")
            appendLine("DTEND;VALUE=DATE:${endDate.toIcsDate()}")
            appendLine("SUMMARY:${title.replace("\n", "\\n")}")
            appendLine("DESCRIPTION:${description.replace("\n", "\\n")}")
            appendLine("END:VEVENT")
            appendLine("END:VCALENDAR")
        }

        val blob = js("new Blob([icsContent], {type: 'text/calendar;charset=utf-8'})")
        val url = js("URL.createObjectURL(blob)") as String

        val anchor = document.createElement("a") as HTMLAnchorElement
        anchor.href = url
        anchor.download = "evento.ics"
        document.body?.appendChild(anchor)
        anchor.click()
        document.body?.removeChild(anchor)
        js("URL.revokeObjectURL(url)")
    }
}
